


















import { Vue, Component } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import {
  OPEN_CHANGES_NOTIFICATION_MODAL, SET_CREATE_FORM_LOADING,
  SET_OPEN_CHANGES_NOTIFICATION_MODAL, SET_OPEN_CHOOSE_FORM_OFFICE_MODAL,
} from '@/types/form.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';

@Component({})
export default class ChangesNotification extends Vue {

  @Mutation(SET_OPEN_CHANGES_NOTIFICATION_MODAL, StoreNamespace.FORM) public setOpenChangesNotificationModal;
  @Mutation(SET_OPEN_CHOOSE_FORM_OFFICE_MODAL, StoreNamespace.FORM) public setOpenChooseFormOfficeModal;
  @Mutation(SET_CREATE_FORM_LOADING, StoreNamespace.FORM) public setCreateFormLoading;

  @Getter(OPEN_CHANGES_NOTIFICATION_MODAL, StoreNamespace.FORM) public openChangesNotificationModal!: boolean;

  public mounted() {
    this.setOpenChooseFormOfficeModal(false);
  }

  public closeDialog(): void {
    this.setCreateFormLoading(false);
    this.setOpenChangesNotificationModal(false);
  }

  public createNewForm(): void {
    this.setOpenChangesNotificationModal(false);
    this.$emit('dialogConfirm');
  }

  public destroyed() {
    this.setOpenChangesNotificationModal(false);
  }

}
